/* istanbul ignore file */
export enum EventTemplateStatus {
  All = "all",
  Active = "active",
  Archived = "archived"
}
